export default __webpack_public_path__ + "static/media/clock.8bab115a.svg";